import React from 'react';
import Pagination from 'rc-pagination';
import {FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/messages';
import s from 'rc-pagination/assets/index.css';
import c from '../../../styles/rc-pagination.css';

function CustomPagination({ total, defaultCurrent, defaultPageSize, handleChange, current }) {

  const renderShowTotal = (total, range) => (
    <div>
      <span>{range[0]}</span>
      <span>&nbsp;–&nbsp;</span>
      <span>{range[1]}</span>
      <span>&nbsp;of&nbsp;</span>
      <span className="paginationRtl">{total}</span>
      <span>&nbsp;<FormattedMessage {...messages.rentals} /></span>
    </div>
  );

  return (
    <div className="spaceTop4">
      <Pagination
        defaultCurrent={defaultCurrent}
        current={current}
        total={total}
        defaultPageSize={defaultPageSize}
        onChange={handleChange}
        showTotal={renderShowTotal}
        locale="en_US"
        prevIcon={<span>&#8249;</span>}
        nextIcon={<span>&#8250;</span>}
        jumpPrevIcon={
          <span className="rc-pagination-jump-custom-icon">
            <span className="rc-pagination-jump-beforeHover-icon">&#8226;&#8226;&#8226;</span>
            <span className="rc-pagination-jump-afterHover-icon">&#8249;&#8249;</span>
          </span>
        }
        jumpNextIcon={
          <span className="rc-pagination-jump-custom-icon">
            <span className="rc-pagination-jump-beforeHover-icon">&#8226;&#8226;&#8226;</span>
            <span className="rc-pagination-jump-afterHover-icon">&#8250;&#8250;</span>
          </span>
        }
        align="center"
      />
    </div>
  );
}

export default withStyles(s, c)(CustomPagination);
